export const WIDGET_Z_INDEX = 1000;
export const TOAST_Z_INDEX = WIDGET_Z_INDEX + 1;
